import { useState } from "react";
import { Link } from "react-router-dom";
import { FiMail, FiArrowLeft, FiCheckCircle, FiAlertCircle } from "react-icons/fi"; // Ícones profissionais
import api from "../../services/api";
import "./RecuperarSenha.scss";

const LOGO_URL = "https://res.cloudinary.com/dhy96qtc9/image/upload/v1769419088/uploads_istudo/gyviusvabxpnealiltse.png";

export default function RecuperarSenhaInstituicao() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");
  const [ok, setOk] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErro("");

    const value = String(email || "").trim().toLowerCase();
    if (!value) {
      setErro("Por favor, informe seu e-mail.");
      return;
    }

    setLoading(true);
    try {
      // Simulação de chamada API
       await api.post("/auth/forgot-password", {
         email: value,
         app: "instituicoes",
       });

      setOk(true);
    } catch (err) {
      setErro("Não foi possível enviar agora. Tente novamente em instantes.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="forgot-password-container">
      <div className="glass-card animate-entrance">
        
        <div className="logo-container">
          <img src={LOGO_URL} alt="Logo Istudo" className="company-logo" />
        </div>

        {/* Renderização Condicional: Sucesso vs Formulário */}
        {ok ? (
          // --- TELA DE SUCESSO ---
          <div className="success-content animate-fade-in">
            <FiCheckCircle className="success-icon" />
            <h2>Solicitação enviada!</h2>
            <p>
              Se existir uma conta para <strong>{email}</strong>, você receberá um link com instruções em instantes.
            </p>
            
            <Link to="/" className="btn-primary btn-back-login">
              <FiArrowLeft /> Voltar para o Login
            </Link>
          </div>
        ) : (
          // --- FORMULÁRIO ---
          <div className="form-content animate-fade-in">
            <h1>Recuperar senha</h1>
            <p className="subtitle">
              Informe o e-mail associado à sua conta para receber o link de redefinição.
            </p>

            <form onSubmit={onSubmit}>
              <div className={`input-group ${erro ? 'has-error' : ''}`}>
                <label htmlFor="email">E-mail profissional</label>
                <div className="input-wrapper">
                  <FiMail className="input-icon" />
                  <input
                    id="email"
                    type="email"
                    placeholder="nome@empresa.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    inputMode="email"
                    autoComplete="username"
                    disabled={loading}
                  />
                </div>
                {erro && (
                  <span className="error-msg">
                    <FiAlertCircle style={{ marginRight: 4 }} /> {erro}
                  </span>
                )}
              </div>

              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? (
                  <span className="loading-state">Enviando...</span>
                ) : (
                  "Enviar link de recuperação"
                )}
              </button>
            </form>

            <div className="footer-links">
              <Link to="/" className="back-link-simple">
                <FiArrowLeft /> Voltar para o login
              </Link>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}